import { Chess } from "chess.js";
import { Dispatch, SetStateAction } from "react";
import { GameState, RemoteNavigationState } from "../context/gameContextTypes";
import { INITIAL_MULTIPLAYER_STATE, MultiplayerState } from "../context/MultiplayerContext";

/**
 * Restarts the game by creating a new Chess instance and resetting the game state.
 * Easy to win: "r3kbnr/PPP1pppp/4ppnb/5ppq/8/8/4PPPP/RNBQKBNR w KQkq - 0 1"
 * Stalemate Game: "7k/5Q2/6K1/8/8/8/8/8 b - - 0 1"
 * Caputured Pieces: "8/8/2n5/4k3/4K3/2B5/8/3Q1R2 w - - 0 1"
 * Pawns Switched Sides: "rnbqkbnr/PPPPPPPP/8/8/8/8/pppppppp/RNBQKBNR w KQkq - 0 1",
 * Easy Capture: "rnbqkbnr/p1p1p1p1/1p1p1p1p/P1P1P1P1/1p1p1p1p/1P1P1P1P/p1p1p1p1/RNBQKBNR w KQkq - 0 1"
 * Place the restart state in the string after isDev.
 */
export function restartGame(setGameState: Dispatch<SetStateAction<GameState>>) {
    const isDev = !window.location.origin.includes("sbgtv.tech");

    const debugFen = "r3kbnr/PPP1pppp/4ppnb/5ppq/8/8/4PPPP/RNBQKBNR w KQkq - 0 1";

    const fen = isDev ? debugFen : undefined;

    const newGame = new Chess(fen);
    setGameState((prev) => ({
        ...prev,
        game: newGame,
        lastMove: null,
        capturedPieces: {
            white: [],
            black: [],
        },
    }));
    localStorage.removeItem("ai-chessGameState");
}

export function undoLastMove(setGameState: Dispatch<SetStateAction<GameState>>) {
    setGameState((prev) => {
        if (!prev.game) return prev;
        const WHITEARRAY = [...prev.capturedPieces.white]; // Makes copies of the cpautred-peices arrays
        const BLACKARRAY = [...prev.capturedPieces.black];
        const undoneAI = prev.game.undo(); // undo AI move
        const undonePlayer = prev.game.undo(); // undo players move
        if (undonePlayer && undonePlayer.captured) {
            if (undonePlayer.color === "w") {
                WHITEARRAY.pop();
            } else {
                BLACKARRAY.pop();
            }
        }

        if (undoneAI && undoneAI.captured) {
            if (undoneAI.color === "b") {
                BLACKARRAY.pop();
            } else {
                WHITEARRAY.pop();
            }
        }

        // Force a complete re-render by temporarily setting a different position
        // This ensures react-chessboard rebuilds the DOM properly
        setTimeout(() => {
            setGameState((current) => ({
                ...current,
            }));
        }, 1);

        return {
            ...prev,
            capturedPieces: {
                white: WHITEARRAY,
                black: BLACKARRAY,
            },
            lastMove: null,
        };
    });
}
/**
 * Handles the home button click by closing the WebSocket connection and
 * setting the game state to the home screen.
 */
export function handleHome(
    setGameState: Dispatch<SetStateAction<GameState>>,
    setRemoteNavigation: Dispatch<SetStateAction<RemoteNavigationState>>,
    setMultiplayerState: Dispatch<SetStateAction<MultiplayerState>>,
) {
    setRemoteNavigation({
        isInMenuIcons: false,
        remoteClickSquare: null,
        remoteOverSquare: null,
        selectedMenuIcon: "Undo",
        isInGameOverMenu: false,
        selectedGameOverIcon: null,
    });
    setGameState((prevState) => ({ ...prevState, showGame: false }));
    setMultiplayerState(INITIAL_MULTIPLAYER_STATE);
}
